import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { adminApi, downloadCsv } from "@/admin/adminApi";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

export default function Leads() {
  const [leads, setLeads] = useState(null);
  useEffect(() => { adminApi.get("/leads").then((r) => setLeads(r.data)).catch(() => setLeads([])); }, []);
  const exportCsv = () => downloadCsv("/leads-export", "wonder-parcel-leads.csv").catch(() => toast.error("Export failed"));

  return (
    <div data-testid="admin-leads">
      <div className="mb-5 flex items-center justify-between">
        <div><h1 className="font-display text-2xl">Notify Leads</h1><p className="text-sm text-wp-ink-muted">People waiting for upcoming initiatives.</p></div>
        <Button onClick={exportCsv} variant="outline" className="rounded-xl" data-testid="leads-export-button"><Download className="mr-1.5 h-4 w-4" /> CSV</Button>
      </div>
      <div className="overflow-hidden rounded-wp-lg border border-border bg-card shadow-wp-soft">
        {leads === null ? <div className="space-y-2 p-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-10 w-full" />)}</div>
          : leads.length === 0 ? <div className="p-10 text-center text-wp-ink-muted">No leads yet.</div>
          : (
            <Table>
              <TableHeader><TableRow><TableHead>Email</TableHead><TableHead>Initiative</TableHead><TableHead>Date</TableHead></TableRow></TableHeader>
              <TableBody>
                {leads.map((l) => (
                  <TableRow key={l.id}>
                    <TableCell className="text-sm font-medium">{l.email}</TableCell>
                    <TableCell>{l.initiative ? <Badge className="border-0 bg-wp-blush-100 text-wp-rose-strong">{l.initiative}</Badge> : <span className="text-wp-ink-muted">—</span>}</TableCell>
                    <TableCell className="text-sm text-wp-ink-muted">{l.created_at ? new Date(l.created_at).toLocaleDateString() : "—"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
      </div>
    </div>
  );
}
